<template>
  <div class="table-page-search-wrapper">
    <a-form :layout="layout">
      <a-row :gutter="gutter">
        <a-col :md="spanMd" :sm="24">
          <a-form-item label="编号">
            <a-input
              placeholder="请输入编号"
              :allowClear="true"
              autocomplete="off"
              v-model="searchModel.productNumber"
            />
          </a-form-item> </a-col
        ><a-col :md="spanMd" :sm="24">
          <a-form-item label="生产线">
            <a-select v-model="searchModel.productLine" :allowClear="true" placeholder="请选择生产线">
              <a-select-option v-for="(item, indexd) in productLineList" :key="indexd" :value="item.code">
                {{ item.name }}
              </a-select-option>
            </a-select>
          </a-form-item> </a-col
        ><a-col :md="spanMd" :sm="24">
          <a-form-item label="产品名称">
            <a-input
              placeholder="请输入产品名称"
              :allowClear="true"
              autocomplete="off"
              v-model="searchModel.productName"
            />
          </a-form-item> </a-col
        ><a-col :md="4" :sm="24">
          <span
            class="table-page-search-submitButtons"
            :style="(advanced && { float: 'right', overflow: 'hidden' }) || {}"
          >
            <a-button type="primary" @click="search">查询</a-button>
            <a-button style="margin-left: 8px" @click="clearSearch">重置</a-button>
          </span>
        </a-col>
      </a-row>
    </a-form>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'ProductSearchForm',
  mounted() {},
  computed: {
    ...mapState({
      productLineList: (state) => state.product.productLineList,
    }),
  },
  data() {
    return {
      layout: 'inline',
      gutter: 48,
      spanMd: 6,
      spanSm: 24,
      showExpend: false,

      searchModel: {},
      advanced: false, // 是否展开
    }
  },
  methods: {
    // 搜索框展开
    toggleAdvanced() {
      this.advanced = !this.advanced
    },
    // 点击查询按钮
    search() {
      for (var key in this.searchModel) {
        if (this.searchModel[key] === undefined || this.searchModel[key] === null || this.searchModel[key] === '') {
          delete this.searchModel[key]
        }
      }
      this.$emit('setSearchCondition', this.searchModel)
    },
    // 点击复位按钮
    clearSearch() {
      this.searchModel.productNumber = ''
      this.searchModel.productLine = ''
      this.searchModel.productName = ''

      this.$emit('clearSearch', this.searchModel)
    },
    // 获取select列表
  },
}
</script>

<style scoped lang="less"></style>
